import React, { FC, useMemo } from 'react';
import { startOfToday } from 'date-fns';
import { Text } from '@moda/om';
import { PdpInfoContainerFragment_masterVariant_processDeliveryDates as DeliveryDates } from '../../../generated/types/PdpInfoContainerFragment';
import { formatDeliveryDate } from '../formatDeliveryDate';

interface Props {
  deliveryDates: DeliveryDates | null;
}

export const PdpDeliveryInfo: FC<Props> = ({ deliveryDates }) => {
  const shippingStart = useMemo(
    () => (deliveryDates?.deliveryStartsOn ? new Date(deliveryDates.deliveryStartsOn) : undefined),
    [deliveryDates]
  );
  const shippingEnd = useMemo(
    () => (deliveryDates?.deliveryEndsOn ? new Date(deliveryDates.deliveryEndsOn) : undefined),
    [deliveryDates]
  );

  if (!shippingEnd) return null;

  const today = startOfToday();

  if (shippingStart && shippingStart > today) {
    return (
      <Text treatment="body2" color="cement">
        Expected to ship{' '}
        {`${formatDeliveryDate(shippingStart)} - ${formatDeliveryDate(shippingEnd)}`}
      </Text>
    );
  }

  if (shippingEnd > today) {
    return (
      <Text treatment="body2" color="cement">
        Expected to ship by {formatDeliveryDate(shippingEnd)}
      </Text>
    );
  }

  return null;
};
